import script from "./ExamDictationPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamDictationPanel.vue?vue&type=script&setup=true&lang=js"

import "./ExamDictationPanel.vue?vue&type=style&index=0&id=06bfafbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06bfafbe"]])

export default __exports__